import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {FlightModeGameAssets} from "./FlightModeGameAssets";
import {FlightModeSound} from "./misc/FlightModeSound";
import {FlightModeBackgroundElements} from "./objects/views/FlightModeBackgroundElements";
import {FlightModeModel} from "./misc/FlightModeModel";
import {FlightModeWinView} from "./objects/views/FlightModeWinView";
import {FlightModeTransitionScreenView} from "./objects/views/FlightModeTransitionScreenView";
import {TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {RestoreUtils} from "./misc/RestoreUtils";
import {FlightModeReelView} from "./objects/views/FlightModeReelView";
import {FlightModeForegroundElements} from "./objects/views/FlightModeForegroundElements";
import {
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {Speedster} from "./misc/Speedster";
import {FlowWrapper} from "./presentations/FlowWrapper";
import {DoNothing} from "./presentations/DoNothing";
import {DoNormalBet} from "./presentations/DoNormalBet";
import {NormalReelStop} from "./presentations/NormalReelStop";
import {NormalWin} from "./presentations/NormalWin";
import {FreeSpinsIntro, FreeSpinsRestoreIntro} from "./presentations/FreesSpinIntro";
import {BrokeBankPresentation} from "./presentations/BrokeBankPresentation";
import {FreeSpinsOutro} from "./presentations/FreesSpinOutro";
import {DoZeroBet} from "./presentations/DoZeroBet";
import {ExplodeSymbols} from "./presentations/ExplodeSymbols";
import {ExplodeBombs} from "./presentations/ExplodeBombs";
import {LockMaxWinSymbols} from "./presentations/LockMaxWinSymbols";
import {ActivateMultiplierSymbols} from "./presentations/ActivateMultiplierSymbols";
import {UseXHole} from "./presentations/UseXHole";
import {WinCountUp} from "./presentations/WinCountUp";
import {SeedableRandom} from "./misc/SeedableRandom";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {ShowExtraSpinPrompt} from "./presentations/ShowExtraSpinPrompt";
import {SetStartingMultiplier} from "./presentations/SetStartingMultiplier";
import {ActivateGoldenMultiplier} from "./presentations/ActivateGoldenMultiplier";
import {ExplodeMultipliers} from "./presentations/ExplodeMultipliers";


export class FlightMode extends SlotGame {
    public static model: FlightModeModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: FlightModeSound;
    public static gameFlowController: GameFlowController;

    public static backgroundElements: FlightModeBackgroundElements;
    public static foregroundElements: FlightModeForegroundElements;
    public static reelView: FlightModeReelView;
    public static winView: FlightModeWinView;
    public static transitionScreen: FlightModeTransitionScreenView;

    public static seedableRandom:SeedableRandom;

    public static isWinBelowStake(winAmount?:number): boolean {
        const win = winAmount != undefined ? winAmount : this.getAccumulatedRoundWin();
        return FlightMode.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (win <= this.getBetPrice());
    }


    public static getBetPrice(): number {
        const betLevel: string = FlightMode.apiPlugin.freeBets.hasFreeBets() ? FlightMode.apiPlugin.freeBets.getBet() : FlightMode.apiPlugin.betLevel.getLevel();
        let price: number = FlightMode.model.playedBetValue || parseFloat(betLevel);
        if (FlightMode.model.wasFeatureBuy || FlightMode.model.isBoostedBet()) {
            for (let index = 0; index < FlightMode.model.featureBuyTimesBetValue.length; index++) {
                if (FlightMode.model.featureBuyTimesBetValue[index].name === FlightMode.model.buyFeatureName) {
                    price *= FlightMode.model.featureBuyTimesBetValue[index].price;
                    price = MathHelper.roundToDecimals(price, 2);
                    break;
                }
            }
        }
        return price
    }

    private static getAccumulatedRoundWin(): number {
        return FlightMode.model.accumulatedRoundWin;
    }

    public static updateKeypadWin() {
        FlightMode.keypadPlugin.setWin(
            FlightMode.model.accumulatedRoundWin,
            true, //FlightMode.model.accumulatedRoundWin != FlightMode.model.responseWin,
            FlightMode.isWinBelowStake());
    }

    getNoWinGameData(): any {
        return{
            "reels": [
                [
                    "L1",
                    "M3",
                    "L4",
                    "MAX"
                ],
                [
                    "M5",
                    "L2",
                    "L1",
                    "MAX"
                ],
                [
                    "M3",
                    "M2",
                    "M5",
                    "MAX"
                ],
                [
                    "M3",
                    "M2",
                    "L2",
                    "MAX"
                ],
                [
                    "M2",
                    "L1",
                    "L2",
                    "MAX"
                ],
                [
                    "M4",
                    "M2",
                    "L2",
                    "MAX"
                ]
            ],
            "evaluatedReels": [
                [
                    "L1",
                    "M3",
                    "L4",
                    "MAX"
                ],
                [
                    "M5",
                    "L2",
                    "L1",
                    "MAX"
                ],
                [
                    "M3",
                    "M2",
                    "M5",
                    "MAX"
                ],
                [
                    "M3",
                    "M2",
                    "L2",
                    "MAX"
                ],
                [
                    "M2",
                    "L1",
                    "L2",
                    "MAX"
                ],
                [
                    "M4",
                    "M2",
                    "L2",
                    "MAX"
                ]
            ],
            "betWayWins": [],
            "playedBetValue": 1,
            "win": 0,
            "accumulatedRoundWin": 0,
            "fsRoundWin": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "serverTestInfo": {},
            "sizes": [
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ]
            ],
            "spinWin": 0,
            "reelsAfterAvalanche": [
                [
                    "L1",
                    "M3",
                    "L4",
                    "MAX"
                ],
                [
                    "M5",
                    "L2",
                    "L1",
                    "MAX"
                ],
                [
                    "M3",
                    "M2",
                    "M5",
                    "MAX"
                ],
                [
                    "M3",
                    "M2",
                    "L2",
                    "MAX"
                ],
                [
                    "M2",
                    "L1",
                    "L2",
                    "MAX"
                ],
                [
                    "M4",
                    "M2",
                    "L2",
                    "MAX"
                ]
            ],
            "symbolSizesAfterAvalanche": [
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ]
            ],
            "multiplier": 1,
            "isExtraSpin": false
        };
    }


    public getSymbolString(key: string, data: {
        3: number,
        4: number,
        5: number,
        6: number,
    }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                 <div class="payout">
                    <span class="number">6</span>
                    <span class="multiplier" data-multiplier="${data[6] * 0.05}">${data[4] * 0.05}</span>
                </div>
                 <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[4] * 0.05}</span>
                </div>
                 <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
 
            </div>
            </div>
        `;
    }

    public getPaytable(): Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });


        const symbolDataValueData = FlightMode.model.symbolValues;

        return super.getPaytable().then((text:string)=>{
            const data : any = {
                godModeValue : this.getGodModeValue(),
                replaceWincapInfo: FlightMode.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showLowProbabilityGfx: FlightMode.apiPlugin.gameClientConfiguration.showLowProbabilityGfx
            }
            for (let key in symbolDataValueData) {
                text = text.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]));
            }

            FlightMode.model.initData.featureBuyTimesBetValue
                .forEach((featureBuyTimesBetValue:{name:string, price:number}) => {
                    data[featureBuyTimesBetValue.name] =
                        featureBuyTimesBetValue.price % 1 != 0
                            ? featureBuyTimesBetValue.price.toFixed(2)
                            : featureBuyTimesBetValue.price.toString();
                });
            return FlightMode.apiPlugin.translations.render(text, data);
        });
    }

    public getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#actionSpinsAllowed", "g"), (FlightMode.apiPlugin.gameClientConfiguration.actionSpin ? "" : "actionSpinsNotAllowed"));

            const gambleRoundCloseTime =
                FlightMode.apiPlugin.gameClientConfiguration.gambleGameRoundCloseIntervalHours;

            const data: any = {
                replaceWincapInfo: FlightMode.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showLowProbabilityGfx: FlightMode.apiPlugin.gameClientConfiguration.showLowProbabilityGfx,
                showBaseGameHighestWinInRules: FlightMode.apiPlugin.gameClientConfiguration.showBaseGameHighestWinInRules,
                replaceSlotsInGameRules: FlightMode.apiPlugin.gameClientConfiguration.replaceSlotsInGameRules
            }
    
   let translatedContent = FlightMode.apiPlugin.translations.render(value,data);
            translatedContent =
                translatedContent.replace(
                    new RegExp("#gambleCloseInterval", "g"),
                    `${gambleRoundCloseTime}`
                );

            return translatedContent;
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            FlightMode.model = new FlightModeModel(SlotGame.apiPlugin, true);
            FlightMode.gameFlowController = new GameFlowController(SlotGame.apiPlugin, FlightMode.model);
            FlightMode.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            FlightMode.gameFlowController.addGameModeFlowStatePresentationMap(
                GameMode.NORMAL,
                new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, FlowWrapper.createFlow([
                        new DoNothing()
                    ])],
                    [FlowState.BET, FlowWrapper.createFlow([
                        new LockMaxWinSymbols(),
                        new DoNormalBet(),
                    ])],
                    [FlowState.RESULT, FlowWrapper.createFlow([
                        new SetStartingMultiplier(),
                        new NormalReelStop()
                    ])],
                    [FlowState.WIN, FlowWrapper.createFlow([
                        new NormalWin(),
                        new ActivateMultiplierSymbols(),
                        new ActivateGoldenMultiplier(),
                        new FreeSpinsIntro(),
                        new ExplodeSymbols(),
                        new ExplodeBombs(),
                        new ExplodeMultipliers(),
                        new UseXHole(),
                        new BrokeBankPresentation(),
                    ])]
                ]));
            FlightMode.gameFlowController.addGameModeFlowStatePresentationMap(
                "NORMAL_AVALANCHE",
                new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, FlowWrapper.createFlow([
                        new DoZeroBet(),
                    ])],
                    [FlowState.RESULT, FlowWrapper.createFlow([
                        new NormalReelStop()
                    ])],
                    [FlowState.WIN, FlowWrapper.createFlow([
                        new NormalWin(),
                        new WinCountUp(),
                        new ActivateMultiplierSymbols(),
                        new ActivateGoldenMultiplier(),
                        new FreeSpinsIntro(),
                        new ExplodeSymbols(),
                        new ExplodeBombs(),
                        new ExplodeMultipliers(),
                        new UseXHole(),
                        new BrokeBankPresentation(),
                    ])]
                ]));
            FlightMode.gameFlowController.addGameModeFlowStatePresentationMap(
                GameMode.FREESPIN,
                new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, FlowWrapper.createFlow([
                        new FreeSpinsRestoreIntro(),
                        new DoZeroBet(),
                    ])],
                    [FlowState.RESULT, FlowWrapper.createFlow([
                        new NormalReelStop()
                    ])],
                    [FlowState.WIN, FlowWrapper.createFlow([
                        new NormalWin(),
                        new ActivateMultiplierSymbols(),
                        new ActivateGoldenMultiplier(),
                        new FreeSpinsOutro(),
                        new ExplodeSymbols(),
                        new ExplodeBombs(),
                        new ExplodeMultipliers(),
                        new UseXHole(),
                        new BrokeBankPresentation(),
                    ])]
                ]));
            FlightMode.gameFlowController.addGameModeFlowStatePresentationMap(
                "FREESPIN_AVALANCHE",
                new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, FlowWrapper.createFlow([
                        new DoZeroBet()
                    ])],
                    [FlowState.RESULT, FlowWrapper.createFlow([
                        new NormalReelStop()
                    ])],
                    [FlowState.WIN, FlowWrapper.createFlow([
                        new NormalWin(),
                        new WinCountUp(),
                        new ActivateMultiplierSymbols(),
                        new ActivateGoldenMultiplier(),
                        new FreeSpinsOutro(),
                        new ExplodeSymbols(),
                        new ExplodeBombs(),
                        new ExplodeMultipliers(),
                        new UseXHole(),
                        new BrokeBankPresentation(),
                    ])]
                ]));
            FlightMode.gameFlowController.addGameModeFlowStatePresentationMap(
                "EXTRA_SPIN",
                new Map<FlowState, FlowStatePresentation>([
                    [FlowState.IDLE, FlowWrapper.createFlow([
                        new ShowExtraSpinPrompt()
                    ])],
                    [FlowState.RESULT, FlowWrapper.createFlow([
                        new DoNothing()
                    ])],
                    [FlowState.WIN, FlowWrapper.createFlow([
                        new DoNothing(),
                    ])]
                ]));

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(FlightModeGameAssets.RESOURCES_GROUPS);
            FlightMode.assetLoader = new AssetLoader(FlightMode.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), FlightMode.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {

            FlightMode.soundPlayer.switchMusic(FlightModeSound.INTRO_MUSIC);
            RestoreUtils.startupGame();

            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;

            FlightMode.gameFlowController.start();

            if (!FlightMode.model.isRestore && !FlightMode.apiPlugin.isReplay)
                FlightMode.soundPlayer.playSound("gameStartOneShot");

            const isBaseGame = !FlightMode.model.isFreespins() || FlightMode.model.isExtraSpinPrompt()
            const scatterCount = FlightMode.model.initData.scatterCount;
            const music = isBaseGame
                          ? FlightModeSound.BASE_GAME_MUSIC
                          : FlightModeSound.getFreespinsMusic(scatterCount)
            FlightMode.soundPlayer.switchMusic(music);

            return value;
        });
    }

    private getGodModeValue(): string {
        for (let i: number = 0; i < FlightMode.model.featureBuyTimesBetValue.length; i++) {
            if (FlightMode.model.featureBuyTimesBetValue[i].name === "GOD_MODE") {
                return FlightMode.model.featureBuyTimesBetValue[i].price.toString();
            }
        }

        return "";
    }

    private createViewsAndComponents() {
        //Non views
        FlightMode.soundPlayer = new FlightModeSound();
        FlightMode.seedableRandom = new SeedableRandom(FlightMode.model.events!);

        //Static views
        FlightMode.backgroundElements = new FlightModeBackgroundElements();
        FlightMode.reelView = new FlightModeReelView();
        FlightMode.foregroundElements = new FlightModeForegroundElements();
        FlightMode.winView = new FlightModeWinView();
        FlightMode.transitionScreen = new FlightModeTransitionScreenView();

        NolimitApplication.addLayerAt("Speedster", new Speedster());
        NolimitApplication.addLayerAt(FlightMode.transitionScreen.name, FlightMode.transitionScreen, 0);
        NolimitApplication.addLayerAt(FlightMode.winView.name, FlightMode.winView, 0);
        NolimitApplication.addLayerAt(FlightMode.foregroundElements.name, FlightMode.foregroundElements, 0);
        NolimitApplication.addLayerAt(FlightMode.reelView.name, FlightMode.reelView, 0);
        NolimitApplication.addLayerAt(FlightMode.backgroundElements.name, FlightMode.backgroundElements, 0);
    }

    public getNolimitBonusDisplayConfiguration():BonusFeatureDisplayConfigurationList {

        return {
            GOD_MODE:{
                displayName:"GOD MODE",
                replacePopUpContent:(content:BonusBuyPopUpContent) => {
                    const warningTextText = "Warning: 1 spin!"
                    const warningText = new Label(FlightMode.apiPlugin.translations.translate(warningTextText),
                                                  content.textLabel.getStyleClone());
                    const scale = Math.min(560 / warningText.width, 1);
                    warningText.scale.set(0.7, 0.7);
                    warningText.anchor.set(0.5, 0.5);
                    warningText.position.set(0, 400);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.8, 0.8);
                    content.textLabel.position.y -= 30;

                    const godModeStillImage = content.featureImage;
                    const godModeSpine = new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.GOD_MODE_POPUP))
                    godModeSpine.state.setAnimation(0, "Loop", true);
                    godModeSpine.position.copyFrom(godModeStillImage);
                    godModeSpine.position.y += 100;

                    content.featureImage = <PIXI.Sprite>(<any>godModeSpine);
                    content.removeChild(godModeStillImage);
                    content.addChild(godModeSpine);


                    return content;
                }
            },
            BOOSTED_BET:{
                displayName:"Bonus Booster",
                displayOrder:0,
            },
        }
    }
}